import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';
import layoutSaga from './layout/saga';
import chartDesignerSaga from './chartDesigner/saga';
import dataModelDesignerSaga from './dataModelDesigner/saga';
import formBuilderSaga from './formBuilder/saga';

import dashbordPageSaga from './dashboardPage/saga';
import radioSaga from './radio/saga';

//import dashbordPageDataSaga from './dashboardPageData/saga';
//import dataSourceSaga from './dataSource/saga';
//import cubeSaga from './cube/saga';
import ChartDesignerConditionallitySaga from './chartDesignerConditionallity/saga';




export default function* rootSaga() {
    yield all([authSaga(), layoutSaga(), chartDesignerSaga(),dataModelDesignerSaga(),formBuilderSaga(),ChartDesignerConditionallitySaga(), dashbordPageSaga(),radioSaga()]);
}
